module.exports = __webpack_public_path__ + "img/location_primary.6e5ebae0.svg";